import React, { useState, useRef, useEffect, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import "./SADocuments.scss";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { BiTrash, BiUpload, BiChevronRight } from "react-icons/bi";
import { FcFolder, FcImageFile, FcDocument, FcFile } from "react-icons/fc";
import { Breadcrumb, Button, Modal } from "react-bootstrap";
import FolderCreate from "./FolderCreate/FolderCreate";
import DmsService from "../../../core/service/DmsService";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import FolderBreadcrumb from "./FolderBreadcrumb/FolderBreadcrumb";
import RiskConfigService from "../../../core/service/RiskConfigService";
import Folder from "./Folder/Folder";
export const ROOT_FOLDER = { name: "Folders", id: null };

function SADocuments({ t }) {
  const [showNewFolder, setShowNewFolder] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [show, setShow] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [directory, setDirectory] = useState([]);
  const [parentId, setParentId] = useState("");
  const [regId, setRegId] = useState("");
  const [currentFolder, setCurrentFolder] = useState([
    { id: "0", name: t("Documents.label") },
  ]);

  const folderId = null;
  const state = useLocation();

  // document.addEventListener("contextmenu", (event) => {
  //   event.preventDefault();
  // });
  useEffect(() => {
    document.addEventListener("click", handleClickOuter);
    return () => {
      document.removeEventListener("click", handleClickOuter);
    };
  }, []);

  useEffect(() => {
    if (folderId === null) {
      getRegulations();
    } else {
      getSubFolders(regId, folderId);
      //getRootFolders();
    }
  }, [folderId]);
  const handleClickOuter = useCallback(() => setShowInfo(false), [showInfo]);

  //const handleCheckbox = () => setShowCheck(!showCheck);
  const getSubFolders = (regulation, parentId = "") => {
    DmsService.getRegulationDoc(regulation, parentId)
      .then((response) => {
        setDirectory([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
    setDirectory([]);
  };
  const callbackFolder = (id, folderName) => {
    let obj = { id: id, name: folderName };
    setCurrentFolder([...currentFolder, obj]);
    if (!regId) {
      setRegId(id);
      getSubFolders(id, "");
    } else {
      setParentId(id);
      getSubFolders(regId, id);
    }
  };
  const getRegulations = () => {
    setRegId("");
    RiskConfigService.getRegulations()
      .then((response) => {
        setDirectory([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      //  console.log("err", error);
      });
  };
  const callbackClose = () => {
    setShowNewFolder(false);
    getSubFolders(regId, parentId);
  };
  const callbackBreadCrumb = (index, folderId) => {
    index === 0
      ? getRegulations()
      : index === 1
      ? getSubFolders(folderId)
      : getSubFolders(regId, folderId);

    let data = [...currentFolder];
    let parent = index > 1 ? data[index - 1].id : "";
    setParentId(parent);
    data.length = index + 1;
    setCurrentFolder(data);
  };
  const callbackDeleteFolder = (item) => {
    item?.container?.id ?   getSubFolders(regId,item.container.id) :  getSubFolders(regId) ;
    
  };
  return (
    <div className="DMSFiles">
      <div className="List_header">
        {currentFolder.length>1 && (
        <FolderBreadcrumb
          currentFolder={currentFolder}
          callbackBreadCrumb={callbackBreadCrumb}
        />
       )} 

        <div className="List_sorts_menu">
          <ul>
            {regId && (
              <li>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setShowNewFolder(true)}
                >
                  {t("NewFolder.label")}
                </button>
                <FolderCreate
                  show={showNewFolder}
                  close={callbackClose}
                  parentId={parentId}
                  regulation={regId}
                />
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="p-2">
        <div className="DMSFiles_folderBox">
          {directory?.map((dir) => (
            <Folder
              folder={dir}
              key={dir.id}
              callbackFolder={callbackFolder}
              deleteFolder={callbackDeleteFolder}
              regulation={regId}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default withTranslation()(SADocuments);
